// extracted by mini-css-extract-plugin
module.exports = {"check":"StrrdmReceiveTableRow_check__1fRlu","times":"StrrdmReceiveTableRow_times__2DgJf","minus":"StrrdmReceiveTableRow_minus__1C8S9"};